<template>
  <Main>
    <div>
      <v-row align="center">
        <v-col cols="2">
          <CancelButton :project-id="projectId" />
        </v-col>
        <v-col cols="8">
          <h1 style="text-align: center; margin-bottom: 10px;">New PSI Creation</h1>
        </v-col>
      </v-row>
    </div>
    <PsiForm
        v-model="form"
        :project-id="projectId"
        :psi-types="psiTypes"
        :default-psi-values="defaultPsiValues"
        @submit="submit"
        class="ma-12"/>
  </Main>
</template>

<script setup>
import Main from '@/Layouts/Main.vue'
import PsiForm from './Form.vue'
import * as $routes from '../../packs/routes';
import {router} from "@inertiajs/vue3";
import LinkButton from "@/Shared/LinkButton.vue";
import {ref} from "vue";
import CancelButton from "@/Shared/CancelButton.vue";

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  },
  psi: {
    type: Object,
    required: true
  },
  psiTypes: {
    type: Array,
    required: true
  },
  defaultPsiValues: {
    type: Object,
    required: true
  }
})

let confirmCancel = ref(false);
const form = props.psi

function submit() {
  router.post($routes.project_psis(props.projectId), form)
}

</script>

<style scoped>

</style>